export interface ICustomer {
	customerId: string
	shortAddress: string
	country: string
	region: string
	city: string
	street: string
	houseNumber: string
	apartmentNumber: string
	postalCode: string
	mobilePhoneNumber: string
	email: string
	status?: CustomerStatus
	title: string
	birthDate: string
	firstName: string
	lastName: string
	bankId: string
	nationalId: string
	canChangeAddress: boolean
	canChangeContactInfo: boolean
	allowMarketingConsent: boolean | null
	newContactDetail: string
	migrationStartedAtUtc?: string
}

export interface IUpdateCustomer {
	customerId: string
	bankId: string
	shortAddress: string
	city: string
	street: string
	houseNumber: string
	apartmentNumber?: string
	postalCode: string
	mobilePhoneNumber?: string
	email?: string
}

export enum CustomerStatus {
	InActive = 'InActive',
	Active = 'Active',
	Suspended = 'Suspended',
	Closed = 'Closed',
	Rejected = 'Rejected',
}

export interface IMarketing {
	isMarketing: boolean
	startDate: string
	endDate: string
	product: string
	market: string
	imageRef: string
	imageLink?: string
}

export interface IFaqItem {
	rowKey: string
	question: string
	answer: string
	order: number
	parent: string
	children: string[]
}
